import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

// Component to clear errors on any field change
function ClearError() {
  const { watch, clearErrors, formState } = useFormContext();
  const previousValues = useRef<unknown>(null);

  useEffect(() => {
    const subscription = watch((value) => {
      // Only clear errors if values actually changed (not just on re-render)
      if (previousValues.current && JSON.stringify(previousValues.current) !== JSON.stringify(value)) {
        // Only clear if there are existing errors
        if (Object.keys(formState.errors).length > 0) {
          clearErrors();
        }
      }
      previousValues.current = value;
    });
    return () => subscription.unsubscribe();
  }, [watch, clearErrors, formState.errors]);

  return null;
}
export default ClearError;
